import {uiPartCreateNamespacedParts} from "@wix/devzai-utils-common";

export const DoppeActionTypeListViewItemParts = uiPartCreateNamespacedParts('DoppeActionTypeListViewItemParts', {
    ItemRoot: 'ItemRoot',
})